import React from "react";
import Keyword from "./Components/index";
import { fromDaily, toDaily } from "fuction/date";
import { withRouter } from "react-router";
import queryString from "query-string";
import useAuth from "Hooks/useAuth";

function Page(props) {
  const auth = useAuth();
  const { date, word } = queryString.parse(props.location.search);

  const fromDate = fromDaily(date);
  const toDate = toDaily(date);
  const activeGroup = auth.state.activeGroup;

  const onClickLineChart = (date) => {
    props.history.push(`/keywords/details?activeGroup=${activeGroup}&word=${word}&date=${date}&interval=hourly`);
  };
  const onClickListButton = (date) => {
    props.history.push(`/keywords/details?activeGroup=${activeGroup}&word=${word}&date=${date}&interval=daily`);
  };
  const handleChangeDateSingle = (date) => {
    props.history.push(`/keywords/daily?activeGroup=${activeGroup}&word=${word}&date=${date}`);
  };

  return (
    <Keyword
      fromDate={fromDate}
      toDate={toDate}
      word={word}
      target="daily"
      unit="hour"
      onClickLineChart={onClickLineChart}
      onClickListButton={onClickListButton}
      handleChangeDateSingle={handleChangeDateSingle}
    />
  );
}

export default withRouter(Page);
